import React, { useState, useEffect } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material"
import { api, showWarning } from "../../../../api"

const ModalStockAgrupado = ({ open, onClose, articulo }) => {
  const [stockData, setStockData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  // ==========================================================================
  // OBTENCIÓN DEL STOCK AGRUPADO DESDE EL BACKEND
  // ==========================================================================
  useEffect(() => {
    const fetchStock = async () => {
      // Validamos que el modal esté abierto y tengamos un artículo válido
      if (!open || !articulo?.artcodigo) return

      setIsLoading(true)
      try {
        const payload = {
          invcodigo: articulo.invcodigo || "01",
          artcodigo: articulo.artcodigo,
        }

        const response = await api.post("/IngEgrporSolicitud/getStockAgrupado", payload)

        let data = []
        if (response?.data?.data) data = response.data.data
        else if (response?.data) data = response.data

        setStockData(data)
      } catch (error) {
        console.error("Error al cargar la consulta de stock:", error)
        showWarning("Ocurrió un error al intentar consultar el stock disponible.")
      } finally {
        setIsLoading(false)
      }
    }

    fetchStock()
  }, [open, articulo])

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ backgroundColor: "#196C87", color: "white", py: 1.5 }}>
        Consulta de Stock Físico Disponible
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            Artículo: {articulo?.artcodigo}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {articulo?.artdescri}
          </Typography>
        </Box>

        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
            <CircularProgress color="primary" />
          </Box>
        ) : (
          <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell width="15%" align="center">
                    Localidad
                  </TableCell>
                  <TableCell width="15%" align="center">
                    Cod. Bodega
                  </TableCell>
                  <TableCell width="50%">Descripción de la Bodega</TableCell>
                  <TableCell width="20%" align="center">
                    Stock Disponible
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stockData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center" sx={{ py: 4, color: "text.secondary" }}>
                      No se encontró stock físico disponible para este artículo en ninguna bodega.
                    </TableCell>
                  </TableRow>
                ) : (
                  stockData.map((row, index) => (
                    <TableRow key={index} hover>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold" color="textSecondary">
                          {row.loccodigo}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          {row.bodcodigo}
                        </Typography>
                      </TableCell>
                      <TableCell>{row.boddescri}</TableCell>
                      <TableCell align="center">
                        <Typography variant="body1" fontWeight="bold" color="secondary">
                          {row.stock_disponible}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, backgroundColor: "#f5f7fa" }}>
        <Button onClick={onClose} color="primary" variant="outlined" sx={{ borderColor: "#196C87", color: "#196C87" }}>
          Cerrar Consulta
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalStockAgrupado
